import React from 'react';
import ManageButton from './ManageButton';
import SaveAndClose from './SaveAndClose';

interface ManageFiltersSelectionProps {
  isManagingFilters: boolean;
  setIsManagingFilters: React.Dispatch<React.SetStateAction<boolean>>;
  editFilters: () => void;
}

const ManageFiltersSelection: React.FC<ManageFiltersSelectionProps> 
= ({ isManagingFilters,
  setIsManagingFilters,
  editFilters
}) => {

  return ( 
    isManagingFilters ?
      <SaveAndClose
        setIsManagingFilters={setIsManagingFilters}
        editFilters={editFilters}
      />
      :
      <ManageButton setIsManagingFilters={setIsManagingFilters} />
  )
}

export default ManageFiltersSelection